<template>
  <nav class="navbar is-fixed-top">
    <!-- brand -->
    <div class="navbar-brand">
      <a href="/" class="navbar-item">
        <img src="/svg/logo.svg" alt="Logo">
      </a>

      <!-- visible on smaller screen -->
      <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="mobileMenu">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <!-- navbar menu -->
    <div class="navbar-menu">
      <div class="navbar-end">

        <!-- notifications -->
        <notifications v-if="isAdmin"/>

        <!-- dashboard -->
        <div class="navbar-item has-dropdown is-hoverable">
          <!-- trigger -->
          <router-link :to="{ name: 'dashboard' }" class="navbar-link is-arrowless">
            <span class="icon">
              <i class="fas fa-th"></i>
            </span>
            <small class="small-text">Dashboard</small>
          </router-link>
          <!-- content -->
          <div class="navbar-dropdown is-right">
            <router-link
            v-if="permission.projects"
            :to="{ name: 'dashboard.projects' }"
            class="navbar-item">
              <span class="icon">
                <i class="fas fa-folder"></i>
              </span>
              <small class="small-text">Projects</small>
            </router-link>
            <router-link
            v-if="permission.suppliers"
            :to="{ name: 'dashboard.suppliers' }"
            class="navbar-item">
              <span class="icon">
                <i class="fas fa-truck-loading"></i>
              </span>
              <small class="small-text">Suppliers</small>
            </router-link>
            <router-link
            v-if="permission.employees"
            :to="{ name: 'dashboard.employees' }"
            class="navbar-item">
              <span class="icon">
                <i class="fas fa-users"></i>
              </span>
              <small class="small-text">Employees</small>
            </router-link>
            <router-link
            v-if="permission.users"
            :to="{ name: 'dashboard.users' }"
            class="navbar-item">
              <span class="icon">
                <i class="fas fa-user-cog"></i>
              </span>
              <small class="small-text">Users</small>
            </router-link>
          </div>
        </div>

        <!-- <router-link
        class="navbar-item"
        :to="{ name: 'reporting' }"
        v-if="isAdmin"
        >
          <span class="icon">
            <i class="fas fa-chart-pie"></i>
          </span>
          <small class="small-text">Reporting</small>
        </router-link> -->

        <!-- User menu -->
        <div class="navbar-item has-dropdown is-hoverable">
          <!-- trigger -->
          <a class="navbar-link is-arrowless">
            <span class="icon">
              <i class="fas fa-user-circle"></i>
            </span>
            <small class="small-text" v-text="userName"></small>
          </a>
          <!-- content -->
          <div class="navbar-dropdown is-right">
            <!-- item -->
            <router-link
            v-if="permission.settings === true"
            :to="{ name: 'dashboard.settings' }"
            class="navbar-item">
              <span class="icon">
                <i class="fas fa-cog"></i>
              </span>
              <small class="small-text">Settings</small>
            </router-link>
            <a @click="logout" class="navbar-item">
              <span class="icon">
                <i class="fas fa-square"></i>
              </span>
              <small class="small-text">Logout</small>
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import Notifications from './Notifications'
export default {
  computed: {
    permission () {
      if (window.User !== undefined) {
        return window.User.role.permission
      }
      return null
    },
    userName () {
      return window.User.name
    },
    isAdmin () {
      return window.User.role.name === 'Administrator'
    }
  },
  methods: {
    // fire this to logout the user
    async logout () {
      try {
        const response = await window.axios.post('/logout')
        if (response.status === 200) {
          window.location.href = '/'
        }
      } catch (error) {
        Promise.reject(error)
      }
    }
  },
  components: {
    Notifications
  }
}
</script>

<style lang="scss" scoped>
.icon {
  padding-right: 0.850rem;
}
.small-text {
  font-size: 0.750rem;
  font-weight: 600;
}
</style>
